import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const CreateAdminPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    secretKey: "", // 특별한 시크릿 키
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("/api/create-admin", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (data.success) {
        alert("관리자 계정이 생성되었습니다!");
        navigate("/login");
      } else {
        alert("관리자 계정 생성에 실패했습니다.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("오류가 발생했습니다.");
    }
  };

  return (
    <div className="create-admin-container">
      <h2>관리자 계정 생성</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>이메일</label>
          <input
            type="email"
            value={formData.email}
            onChange={(e) =>
              setFormData({ ...formData, email: e.target.value })
            }
            required
          />
        </div>

        <div className="form-group">
          <label>비밀번호</label>
          <input
            type="password"
            value={formData.password}
            onChange={(e) =>
              setFormData({ ...formData, password: e.target.value })
            }
            required
          />
        </div>

        <div className="form-group">
          <label>시크릿 키</label>
          <input
            type="password"
            value={formData.secretKey}
            onChange={(e) =>
              setFormData({ ...formData, secretKey: e.target.value })
            }
            required
          />
        </div>

        <button type="submit">관리자 계정 생성</button>
      </form>
    </div>
  );
};

export default CreateAdminPage;
